import Vue from 'vue'
import frag from 'vue-frag'
Vue.directive('frag', frag)
